<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.name"
              placeholder="请输入微信群名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.market"
              placeholder="请输入覆盖市场"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px; padding: 0 2px;"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="handleAdd"
        @edit="handleEdit(arguments)"
        @delete="handleDelete(arguments)"
        @view="handleView(arguments)"
        @dblclick="handleView(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 新增 修改 -->
    <add-edit-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogViewVisible"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 新增 修改
import addEditDialog from './components/addEditDialog'
// 查看
import viewDialog from './components/viewDialog'
// 微信群管理API
import { loadWeChatGroupListDataApi, exportWeChatGroupListDataApi, deleteWeChatGroupApi } from '@/api/v2/weChatGroup'

export default {
  name: 'WeChatGroupView',
  components: { CustomTable2, TableOperation2, addEditDialog, viewDialog },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'we_chat_group_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['we_chat_group_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['we_chat_group_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['we_chat_group_del'],
            prop: 'delete',
            label: '作废',
            method: 'delete'
          },
          {
            permissionSigns: ['we_chat_group_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['we_chat_group_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          name: '',
          market: ''
        },
      },
      id: null,
      dialogAddEditVisible: false,
      dialogViewVisible: false,
      dialogTitle: '',
      eventType: ''
    }
  },
  created () {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80, align: 'center' },
      { prop: 'provinceName', label: '省区', filterColumn: 'ta.name', width: 90 },
      { prop: 'wxId', label: '微信群号', filterColumn: 'twcg.wx_id', width: 180 },
      { prop: 'name', label: '微信群名称', filterColumn: 'twcg.name', width: 200 },
      { prop: 'market', label: '覆盖市场', filterColumn: 'twcg.market', width: 110 },
      { prop: 'memberNumber', label: '群人数', filterColumn: 'twcg.member_number', width: 100 },
      { prop: 'enrollment', label: '注册人数', filterColumn: 'twcg.enrollment', width: 110 },
      { prop: 'certifiedNumber', label: '认证人数', filterColumn: 'IFNULL(tm.certified_number, 0)', width: 110 },
      { prop: 'maintainNumber', label: '运维数量', filterColumn: 'IFNULL(tm.maintain_number, 0)', width: 110 },
      { prop: 'groupOwner', label: '群主', filterColumn: 'twcg.group_owner', width: 130 },
      { prop: 'createBy', label: '群创建人', filterColumn: 'twcg.create_by', width: 130 },
      { prop: 'remark', label: '备注', filterColumn: 'twcg.remark', minWidth: 150 },
      { prop: 'statusValue', label: '状态', filterColumn: 'twcg.status', filterValue: 'status', filterArray: [{ label: '正常', value: 1 }, { label: '已解散', value: 2 }], width: 90 },
      { prop: 'creatorName', filterColumn: 'twcg.creator_name', label: '创建人', width: 100 },
      { prop: 'createTime', filterColumn: 'twcg.create_time', label: '创建时间', width: 150, isBetween: true },
      { prop: 'operatorName', filterColumn: 'twcg.operator_name', label: '操作人', width: 110 },
      { prop: 'operationTime', filterColumn: 'twcg.operation_time', label: '操作时间', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadWeChatGroupListDataApi(_this.masterList.tableQuery).then(response => {
        const { data } = response;
        _this.handleData(data.list || [])
        _this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    //新增
    handleAdd () {
      let _this = this;
      _this.eventType = 'add'
      _this.dialogTitle = '新增微信群'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 修改
    handleEdit (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要修改的微信群', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'edit'
      _this.dialogTitle = '修改微信群'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 查看
    handleView (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的微信群', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'view'
      _this.dialogTitle = '查看微信群'
      _this.dialogViewVisible = !_this.dialogViewVisible
    },
    // 删除
    handleDelete (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要作废的微信群', type: 'warning' })
        return
      }
      let tips = '是否确认作废该微信群？'
      if (args[0].certifiedNumber > 0) {
        tips = '该微信群已存在认证成员，是否确认作废？'
      }
      _this.$confirm(tips, '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        deleteWeChatGroupApi({ id: args[0].id }).then(() => {
          _this.$message({ message: '作废成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportWeChatGroupListDataApi(_this.exportObj).then((response) => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
